import "../styles/Homepage.css";
import { React, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Login } from "../components";
import { UserContext } from "../App";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Homepage() {
  const { userType } = useContext(UserContext);
  const [cookies, setCookie, removeCookie] = useCookies([
    "redirectId",
    "auth_token",
  ]);
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [membershipId, setMembershipId] = useState(null); // Store the company's membershipId
  const [companyStatus, setCompanyStatus] = useState(null); //Store the company's status
  const [isActive, setIsActive] = useState(true); // Store the company's active status
  const [isLoadingMembership, setIsLoadingMembership] = useState(true); // Track if membership level is being fetched
  const [fetchError, setFetchError] = useState(null); // Track any errors during fetch
  // helper to turn "2025-04-10" → "04-10-2025"
  const formatDate = (iso) => {
    if (!iso) return "";
    const [year, month, day] = iso.split("-");
    return `${month}-${day}-${year}`;
  };
  // Fetch announcements for students
  useEffect(() => {
    const fetchAllAnnouncements = async () => {
      try {
        const response = await axios.get("/announcement/public");
        if (response.data.success) {
          setAnnouncements(response.data.announcements);
        } else {
          console.error("Failed to load announcements", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    if (userType === "student") {
      fetchAllAnnouncements();
    }
  }, [userType]);

  // Fetch the company's membershipId and active status if userType is "company"
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      if (userType !== "company") {
        setIsLoadingMembership(false);
        return;
      }

      try {
        //console.log("Fetching company details with token:", cookies.auth_token);
        const response = await axios.get("/api/company/details", {
          headers: { Authorization: `Bearer ${cookies.auth_token}` },
          withCredentials: true,
        });
        //console.log("Company details response:", response.data);
        if (response.data.success) {
          //console.log("Setting membershipId to:", response.data.membershipId);
          setMembershipId(response.data.membershipId);
          setIsActive(response.data.active); // Assuming the API returns the active status
          setCompanyStatus(response.data.status);
        } else {
          console.error("Failed to fetch company details", response.data.message);
          setFetchError(
            response.data.message || "Failed to fetch company details"
          );
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
        setFetchError(error.message || "Error fetching company details");
      } finally {
        setIsLoadingMembership(false);
      }
    };

    fetchCompanyDetails();
  }, [userType, cookies.auth_token]);

  // Handle redirect for jobId
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const jobId = queryParams.get("Jid");
    const redirectId = jobId || cookies.redirectId;

    if (
      redirectId &&
      (userType === "student" || userType === "admin" || userType === "faculty")
    ) {
      navigate(`/researchpositions?Jid=${redirectId}`);
      if (cookies.redirectId) {
        removeCookie("redirectId");
      }
    }
  }, [userType, navigate, location.search, cookies.redirectId, removeCookie]);

  function displayContents() {
    //console.log(
    //  "displayContents called with userType:",
    //  userType,
    //  "membershipId:",
    //  membershipId,
    //  "isActive:",
    //  isActive
    //);

    const studentData = {
      prompt: "Click here to edit your profile.",
      link: "/profile",
      buttonText: "Profile",
      secondPrompt: "Click here to view available jobs and internships.",
      secondLink: "/jobs",
      secondButtonText: "Jobs",
    };
    const adminData = {
      prompt: "Click here to manage students.",
      link: "/students",
      buttonText: "Students",
      secondPrompt: "Click here to manage the list of jobs.",
      secondLink: "/jobs",
      secondButtonText: "Job Board",
    };
    const companyData = {
      prompt: "Click here to see a list of students.",
      link: "/students",
      buttonText: "Students",
      secondPrompt: "Click here to manage your list of jobs.",
      secondLink: "/jobs",
      secondButtonText: "Job Board",
      thirdprompt: "Click here to send out an announcement.",
      thirdlink: "/announcement",
      thirdbuttonText: "Announcement",
      fourthprompt: "Click here to sign up for events.",
      fourthlink: "/eventslist",
      fourthbuttonText: "Events",
    };
    const facultyData = {
      prompt: "Click here to see a list of students who have applied.",
      link: "/students",
      buttonText: "Student Applications",
      secondPrompt: "Click here to manage your list of research positions.",
      secondLink: "/researchpositions",
      secondButtonText: "Research Position Board",
    };

    let data = {};
    if (userType === "student") {
      data = studentData;
    } else if (userType === "admin") {
      data = adminData;
    } else if (userType === "company") {
      data = companyData;
    } else if (userType === "faculty") {
      data = facultyData;
    } else {
      return <Login />;
    }

    if (userType === "admin") {
      //console.log("Rendering admin path");
      return (
        <div className="flex-container">
          <div className="Homepage-page-a flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            <h2 className="text-center font-brand-primary font-bold text-xl mb-4">
              Manage Postings
            </h2>
            {jobsManager()}
            {researchPositionsManager()}
            {eventsManager()}
            {billingManager()}
            {announcementsManager()}
          </div>
          <div className="Homepage-page-a flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            <h2 className="text-center font-brand-primary font-bold text-xl mb-4">
              Manage Tags
            </h2>
            {skillsManager()}
            {locationsManager()}
            {researchAreasManager()}
          </div>
          <div className="Homepage-page-a flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            <h2 className="text-center font-brand-primary font-bold text-xl mb-4">
              Manage Users
            </h2>
            {facultyManager()}
            {adminManager()}
            {studentManager()}
            {companyManager()}
          </div>
        </div>
      );
    } else if (userType === "student") {
      //console.log("Rendering student path");
      return (
        <div className="flex flex-col items-center space-y-8 w-full">
          <div className="Homepage-page flex flex-col w-96 py-4 mt-8 mx-auto rounded-2xl bg-white shadow-lg">
            <div className="Homepage-topText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.prompt}
            </div>
            <Link
              className="Homepage-topButton primary-button bg-brand-secondary mb-2 mx-auto"
              to={data.link}>
              {data.buttonText}
            </Link>
            <div className="Homepage-bottomText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.secondPrompt}
            </div>
            <Link
              className="Homepage-bottomButton primary-button bg-brand-primary mb-2 mx-auto"
              to={data.secondLink}>
              {data.secondButtonText}
            </Link>
            {researchPositionsViewer()}
          </div>
          <div className="bg-white rounded-2xl shadow-md py-4 px-4 w-[95%] mx-auto">
            <h1 className="text-2xl font-bold mb-4">Company Announcements:</h1>
            {(() => {
              const activeAnnouncements = announcements.filter(
                (ann) =>
                  ann.status === "Active" &&
                  ann.expireDate &&
                  new Date(ann.expireDate) >= new Date()
              );
              return activeAnnouncements.length === 0 ? (
                <p className="text-center">
                  No posted announcements currently.
                </p>
              ) : (
                <ul className="space-y-2 max-h-[80vh] overflow-y-auto">
                  {activeAnnouncements.map((ann) => (
                    <li key={ann.announcementId} className="border p-4 rounded">
                      <h3 className="font-bold">{ann.subject}</h3>
                      <p
                        className="whitespace-normal break-words"
                        dangerouslySetInnerHTML={{ __html: addLinksToMessage(ann.message) }}
                      ></p>
                    </li>
                  ))}
                </ul>
              );
            })()}
          </div>
        </div>
      );
    } else if (userType === "faculty") {
      //console.log("Rendering faculty path");
      return (
        <div className="Homepage-page flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
          <div className="Homepage-topText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
            {data.prompt}
          </div>
          <Link
            className="Homepage-firstButton primary-button bg-brand-secondary mb-2 mx-auto"
            to={data.link}>
            {data.buttonText}
          </Link>
          <div className="Homepage-bottomText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
            {data.secondPrompt}
          </div>
          <Link
            className="Homepage-secondButton primary-button bg-brand-primary mb-2 mx-auto"
            to={data.secondLink}>
            {data.secondButtonText}
          </Link>
        </div>
      );
    } else if (userType === "company") {
      if (isLoadingMembership) {
        //console.log("Rendering loading path for company");
        return (
          <div className="Homepage-page flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            <p className="text-center">Loading...</p>
          </div>
        );
      }

      if (fetchError) {
        //console.log("Rendering error path for company");
        return (
          <div className="Homepage-page flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            <p className="text-center text-red-600">{fetchError}</p>
            <button
              className="primary-button bg-brand-secondary mb-2 mx-auto"
              onClick={() => navigate("/login")}>
              Log In Again
            </button>
          </div>
        );
      }

      //console.log("MembershipId before condition:", membershipId);
      //console.log(
      //  "Is CareerFair Only (membershipId === 4):",
      //  membershipId === 4
      //);

      /* ----- Status Indicators ----- */
      if (companyStatus == "New") {
        data.stat = "Your access will be limited until you have been issued an invoice for your contract, feel free to add your contacts in the mean time.";
      } else if (companyStatus == "Renew") {
        data.stat = "You have requested a contract renewal and will be issued an invoice.";
      } else if (companyStatus == "Hold") {
        data.stat = "Your contract has expired, it can be renewed within your profiles setting menu. If you do not renew your contract within 30 days of its expiration you will lose access to this system.";
      } else if (companyStatus == "Inactive") {
        data.stat = "Your contract has expired, it can be renewed within your profiles setting menu. Until you renew your contract you have lost access to this system.";
      } else if (companyStatus == "BilledNew") {
        data.stat = "You have been issued an invoice, please arrange for it to be payed before your contracts listed start date or you may lose access.";
      } else if (companyStatus == "BilledRenew") {
        data.stat = "You have been issued an invoice, please arrange for it to be payed before the end of your original contract or you may lose access.";
      }

      if (membershipId === 4) {
        //console.log("Rendering CareerFair Only path (membershipId === 4)");
        return (
          <div className="Homepage-page flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            {data.stat &&
                <div className="Homepage-thirdText text-center font-brand-primary font-bold text-xl mb-4 mx-4" style={{ border: "dashed .25rem black", borderRadius:".5rem", padding:"10px" }}>
                {data.stat}
              </div>
            }
            <div className="Homepage-thirdText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.fourthprompt}
            </div>
            {isActive ? (
              <Link
                className="Homepage-fourthButton primary-button bg-brand-secondary mb-2 mx-auto"
                to={data.fourthlink}>
                {data.fourthbuttonText}
              </Link>
            ) : (
              <button
                className="Homepage-fourthButton primary-button bg-gray-400 mb-2 mx-auto cursor-not-allowed"
                disabled>
                {data.fourthbuttonText}
              </button>
            )}
          </div>
        );
      } else {
        //console.log("Rendering all other companies path");
        return (
          <div className="Homepage-page flex justify-center flex-col w-96 py-4 mx-auto my-auto rounded-2xl bg-white shadow-lg">
            {data.stat &&
                <div className="Homepage-thirdText text-center font-brand-primary font-bold text-xl mb-4 mx-4" style={{ border: "dashed .25rem black", borderRadius:".5rem", padding:"10px" }}>
                {data.stat}
              </div>
            }
            <div className="Homepage-topText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.prompt}
            </div>
            {isActive ? (
              <Link
                className="Homepage-topButton primary-button bg-brand-secondary mb-2 mx-auto"
                to={data.link}>
                {data.buttonText}
              </Link>
            ) : (
              <button
                className="Homepage-topButton primary-button bg-gray-400 mb-2 mx-auto cursor-not-allowed"
                disabled>
                {data.buttonText}
              </button>
            )}
            <div className="Homepage-bottomText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.secondPrompt}
            </div>
            {isActive ? (
              <Link
                className="Homepage-bottomButton primary-button bg-brand-primary mb-2 mx-auto"
                to={data.secondLink}>
                {data.secondButtonText}
              </Link>
            ) : (
              <button
                className="Homepage-bottomButton primary-button bg-gray-400 mb-2 mx-auto cursor-not-allowed"
                disabled>
                {data.secondButtonText}
              </button>
            )}
            <div className="Homepage-thirdText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.thirdprompt}
            </div>
            {isActive ? (
              <Link
                className="Homepage-thirdButton primary-button bg-brand-secondary mb-2 mx-auto"
                to={data.thirdlink}>
                {data.thirdbuttonText}
              </Link>
            ) : (
              <button
                className="Homepage-thirdButton primary-button bg-gray-400 mb-2 mx-auto cursor-not-allowed"
                disabled>
                {data.thirdbuttonText}
              </button>
            )}
            <div className="Homepage-thirdText text-center font-brand-primary font-bold text-xl mb-4 mx-4">
              {data.fourthprompt}
            </div>
            {isActive ? (
              <Link
                className="Homepage-fourthButton primary-button bg-brand-secondary mb-2 mx-auto"
                to={data.fourthlink}>
                {data.fourthbuttonText}
              </Link>
            ) : (
              <button
                className="Homepage-fourthButton primary-button bg-gray-400 mb-2 mx-auto cursor-not-allowed"
                disabled>
                {data.fourthbuttonText}
              </button>
            )}
          </div>
        );
      }
    } else {
      //console.log("Rendering Login component (default)");
      return <Login />;
    }
  }
  
  const addLinksToMessage = (message) => {
    if(typeof message !== "string")
      return message;
    return message.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\{([^|]*?)\}/g, "<a href='$1' style='color: maroon' target='_blank'>$1</a>").replace(/{(.*?)\|(.*?)}/g, "<a href='$2' style='color: maroon' target='_blank'>$1</a>");
  };

  // Manager functions remain unchanged
  function companyManager() {
    return (
      <div className="Homepage-companyManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of companies.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-primary mb-2 mx-auto"
          to="/companies">
          Companies
        </Link>
      </div>
    );
  }

  function billingManager() {
    return (
      <div className="Homepage-billingManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4"></div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-primary mb-2 mx-auto"
          to="/billing">
          Billing
        </Link>
      </div>
    );
  }

  function skillsManager() {
    return (
      <div className="Homepage-skillsManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of skills.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-secondary mb-2 mx-auto"
          to="/skills">
          Skills
        </Link>
      </div>
    );
  }

  function locationsManager() {
    return (
      <div className="Homepage-locationsManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of locations.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-primary mb-2 mx-auto"
          to="/locations">
          Locations
        </Link>
      </div>
    );
  }

  function researchAreasManager() {
    return (
      <div className="Homepage-researchAreasManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of research areas.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-secondary mb-2 mx-auto"
          to="/researchareas">
          Research Areas
        </Link>
      </div>
    );
  }

  function adminManager() {
    return (
      <div className="Homepage-adminManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of admins.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-primary mb-2 mx-auto"
          to="/admins">
          Admins
        </Link>
      </div>
    );
  }

  function facultyManager() {
    return (
      <div className="Homepage-facultyManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of faculty.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-secondary mb-2 mx-auto"
          to="/faculty">
          Faculty
        </Link>
      </div>
    );
  }

  function researchPositionsManager() {
    return (
      <div className="Homepage-researchPositionsManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          {/*Click here to manage the list of research positions.*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-primary mb-2 mx-auto"
          to="/researchpositions">
          Research Position Board
        </Link>
      </div>
    );
  }

  function researchPositionsViewer() {
    return (
      <div className="Homepage-researchPostionsViewer flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
            font-bold text-xl mb-2 mx-4">
          Click here to view available undergraduate research positions.
        </div>
        <Link
          className="Homepage-topButton primary-button
          bg-brand-secondary mb-2 mx-auto"
          to="/researchpositions">
          Undergraduate Research
        </Link>
      </div>
    );
  }

  function studentManager() {
    return (
      <div className="Homepage-studentManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
              font-bold text-xl mb-2 mx-4">
          {/*"Click here to manage students."*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
            bg-brand-secondary mb-2 mx-auto"
          to={"/students"}>
          {"Students"}
        </Link>
      </div>
    );
  }

  function jobsManager() {
    return (
      <div className="Homepage-jobManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
              font-bold text-xl mb-2 mx-4">
          {/*"Click here to manage the list of jobs."*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
            bg-brand-secondary mb-2 mx-auto"
          to={"/jobs"}>
          {"Job Board"}
        </Link>
      </div>
    );
  }

  function announcementsManager() {
    return (
      <div className="Homepage-announcementsManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
              font-bold text-xl mb-2 mx-4">
          {/*"Click here to manage the list of announcements."*/}
        </div>
        <Link
          className="Homepage-topButton primary-button bg-brand-secondary mb-2 mx-auto"
          to="/adminAnnouncementsSearch">
          Announcements
        </Link>
      </div>
    );
  }

  function eventsManager() {
    return (
      <div className="Homepage-eventsManager flex flex-col justify-center w-96 mx-auto">
        <div
          className="Homepage-topText text-center font-brand-primary
              font-bold text-xl mb-2 mx-4">
          {/*"Click here to manage the list of events."*/}
        </div>
        <Link
          className="Homepage-topButton primary-button
            bg-brand-secondary mb-2 mx-auto"
          to={"/events"}>
          {"Events"}
        </Link>
      </div>
    );
  }

  return (
    <main className="flex-grow">
      <div
        className={
          {
            student: "Homepage-student flex h-full",
            admin: "Homepage-admin flex h-full",
            company: "Homepage-company flex h-full",
            faculty: "Homepage-faculty flex h-full",
          }[userType] || "Homepage flex h-full"
        }>
        {displayContents()}
      </div>
    </main>
  );
}

export default Homepage;